import React, { Component } from 'react'
import PropTypes from 'prop-types'

import View from '../ViewComponents/View'

class PoiBubbleComponent extends Component {

  renderBubbleItem (categoryConfig, poi) {
    if (!categoryConfig || !poi) {
      return null
    }

    const categoryConfigToUse = typeof categoryConfig === 'string'
      ? this.props.referencedConfigs[categoryConfig]
      : categoryConfig

    const key = `bubbleitem_${poi.id}`
    return (
      <div key={key}>
        <div className={categoryConfigToUse.cssClass}>
          <View
            config={categoryConfigToUse.view}
            functions={this.props.functions}
            poi={poi}
          />
        </div>
      </div>
    )
  }

  renderCategoryBubbleItem (categoryConfig, poi) {
    if ((Object.keys(categoryConfig).includes(poi.category))) {
      return this.renderBubbleItem(categoryConfig[poi.category].bubble, poi)
    }
    return null
  }

  render () {
    if (!this.props.poi) {
      return null
    }

    return (
      <div>
        {this.renderCategoryBubbleItem(this.props.config, this.props.poi)}
      </div>
    )
  }

}

PoiBubbleComponent.propTypes = {
  poi: PropTypes.object.isRequired,
  // goBack: PropTypes.func,
  // showDetails: PropTypes.func,
  userPosition: PropTypes.object,
  mapPosition: PropTypes.object,
  // onNavigateToPoi: PropTypes.func,
  height: PropTypes.number,
  functions: PropTypes.object.isRequired,
  config: PropTypes.object.isRequired,
  referencedConfigs: PropTypes.object
}

export default PoiBubbleComponent



// WEBPACK FOOTER //
// ./src/components/TripAdvisor/PoiBubbleComponent.js